import {
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
    map as _$ma,
    createUnknownComponentVNode as _$cc,
    noop as _$no,
} from 'intact';
import {BubbleListItem} from './item';
import {MemoBlock} from '../split/memo';
import {addStyle, getRestProps, isEmptyString} from '../utils';
import {makeStyles} from './styles';
import {Icon} from '../icon';
import {isInvalid, isNumber, noop} from 'intact-shared';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {
        scrollBoxRef,
        scrollContentRef,
        getItems,
        getItemKey,
        getItemRef,
        getSlotParams,
        handleScroll,
        shouldShowEmpty,
        shouldShowHistoryLoading,
        shouldShowScrollToBottom,
        getDefaultHistoryLoadingText,
        onScrollToBottomClick,
    } = this.bubbleList;
    
    let {className, style, maxHeight} = this.get();
    const {k} = this.config;
    const items = getItems();
    const isEmptySlot = (value) => {
        if (isInvalid(value) || isEmptyString(value)) return true;
        if (Array.isArray(value)) return value.every(item => isEmptySlot(item));
        if (value && value.type === 1) return isEmptySlot(value.children);
    
        return false;
    };
    const historyLoadingParams = {
        loadingHistory: this.get('loadingHistory'),
        hasMoreHistory: this.get('hasMoreHistory'),
    };
    const headerSlot = $blocks.header ? $blocks.header(noop) : undefined;
    const listFooterSlot = $blocks.listFooter ? $blocks.listFooter(noop) : undefined;
    const historyLoadingSlot = shouldShowHistoryLoading() && $blocks.historyLoading
        ? $blocks.historyLoading(noop, historyLoadingParams)
        : undefined;
    const emptySlot = shouldShowEmpty() && $blocks.empty ? $blocks.empty(noop) : undefined;
    const hasHeaderSlot = !isEmptySlot(headerSlot);
    const hasListFooterSlot = !isEmptySlot(listFooterSlot);
    const hasHistoryLoadingSlot = !isEmptySlot(historyLoadingSlot);
    const hasEmptySlot = !isEmptySlot(emptySlot);
    const showDefaultHistoryLoading = !$blocks.historyLoading && this.get('loadingHistory');
    const showHistoryLoading = shouldShowHistoryLoading() && (hasHistoryLoadingSlot || showDefaultHistoryLoading);
    const showEmpty = shouldShowEmpty() && (hasEmptySlot || !$blocks.empty);
    const getSlotRenderers = (item, index) => {
        const slotParams = getSlotParams(item, index);
    
        return {
            avatar: $blocks.avatar ? () => $blocks.avatar(noop, slotParams) : undefined,
            roleName: $blocks.roleName ? () => $blocks.roleName(noop, slotParams) : undefined,
            beforeContent: $blocks.beforeContent ? () => $blocks.beforeContent(noop, slotParams) : undefined,
            attachments: $blocks.attachments ? () => $blocks.attachments(noop, slotParams) : undefined,
            content: $blocks.content ? () => $blocks.content(noop, slotParams) : undefined,
            bottom: $blocks.bottom ? () => $blocks.bottom(noop, slotParams) : undefined,
            footer: $blocks.footer ? () => $blocks.footer(noop, slotParams) : undefined,
            loading: $blocks.loading ? () => $blocks.loading(noop, slotParams) : undefined,
            extra: $blocks.extra ? () => $blocks.extra(noop, slotParams) : undefined,
        };
    };
    
    const classNameObj = {
        [`${k}-bubble-list`]: true,
        [className]: className,
        [makeStyles(k)]: true,
    };
    
    if (maxHeight != null) {
        style = addStyle(style, {
            maxHeight: isNumber(maxHeight) ? `${maxHeight}px` : maxHeight,
        });
    }
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this),
        'style': style
    }, [
        (hasHeaderSlot) ?
            _$ce(2, 'div', headerSlot, 0, _$cn(`${k}-bubble-list-header`)) :
            undefined,
        _$ce(2, 'div', (
            _$ce(2, 'div', [
                (showHistoryLoading) ?
                    _$ce(2, 'div', (
                        (hasHistoryLoadingSlot) ?
                            historyLoadingSlot :
                            _$ce(2, 'span', getDefaultHistoryLoadingText(), 0)
                    ), 0, _$cn(`${k}-bubble-list-history`)) :
                    undefined,
                (showEmpty) ?
                    _$ce(2, 'div', (
                        (hasEmptySlot) ?
                            emptySlot :
                            _$ce(2, 'span', '暂无消息', 16)
                    ), 0, _$cn(`${k}-bubble-list-empty`)) :
                    _$ce(2, 'div', (
                        _$ma(items, function($value, $key) {
                            return _$ce(2, 'div', (
                                ($blocks.item) ?
                                    _$cc(MemoBlock, {
                                        'block': $blocks.item,
                                        'children': (
                                            (
                                                (
                                                    (_$blocks['item'] = function($super) {
                                                        return null;
                                                    }),
                                                    (__$blocks['item'] = function($super, data) {
                                                        var block = $blocks['item'];
                                                        var callBlock = function() {
                                                            return _$blocks['item'].call($this, $super, data);
                                                        };
                                                        return block ?
                                                            block.call($this, callBlock, data) :
                                                            callBlock();
                                                    }),
                                                    __$blocks['item'](_$no, getSlotParams($value, $key))
                                                )
                                            )
                                        )
                                    }) :
                                    _$cc(BubbleListItem, {
                                        'item': $value,
                                        'index': $key,
                                        'list': this,
                                        'slotRenderers': getSlotRenderers($value, $key)
                                    })
                            ), 2, null, null, getItemKey($value, $key), getItemRef($value, $key));
                        }, $this)
                    ), 8, _$cn(`${k}-bubble-list-items`))
            ], 0, _$cn(`${k}-bubble-list-scroll-content`), null, null, scrollContentRef)
        ), 2, _$cn(`${k}-bubble-list-scroll`), {
            'ev-scroll': handleScroll
        }, null, scrollBoxRef),
        (hasListFooterSlot) ?
            _$ce(2, 'div', listFooterSlot, 0, _$cn(`${k}-bubble-list-footer`)) :
            undefined,
        (shouldShowScrollToBottom()) ?
            _$ce(2, 'div', (
                ($blocks.scrollToBottom) ?
                    (
                        (_$blocks['scrollToBottom'] = function($super) {
                            return null;
                        }),
                        (__$blocks['scrollToBottom'] = function($super, data) {
                            var block = $blocks['scrollToBottom'];
                            var callBlock = function() {
                                return _$blocks['scrollToBottom'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        }),
                        __$blocks['scrollToBottom'](_$no, {
                            isAtBottom: this.get('$isAtBottom'),
                            scrollToBottom: () => this.scrollToBottom('smooth'),
                        })
                    ) :
                    _$ce(2, 'button', (
                        _$cc(Icon, {
                            'className': _$cn(`${k}-bubble-list-scroll-to-bottom-icon k-icon-down-bold`)
                        })
                    ), 2, _$cn(`${k}-bubble-list-scroll-to-bottom-button`), {
                        'type': 'button',
                        'title': '回到底部',
                        'aria-label': '回到底部',
                        'ev-click': onScrollToBottomClick
                    })
            ), 0, _$cn(`${k}-bubble-list-scroll-to-bottom`)) :
            undefined
    ]);
};